.register-text{
  padding: 10px;
  color: #666;
  letter-spacing: 1px;
}

.register-text .tambr-clear-button{
  padding: 0;
  text-decoration: underline;
}

.checkbox-wrapper{
  margin-top: 10px
}


.checkbox-wrapper input {
  vertical-align: middle;
  margin-right: 0.3rem;    
}

.checkbox-wrapper input:focus+label {
  font-size: inherit;
  transition: none;
}

.tambr-auth-form .tambr-action-buttons{
  margin-top: 20px;
}

.password-hint {
  opacity: 0.9;
  font-size: 10px;
  margin-top: 3px;
  color: #666;
}